// extracted by mini-css-extract-plugin
export default {"inputsWrap":"Form1_inputsWrap__bebww","description":"Form1_description__lJP-F","dataForm":"Form1_dataForm__OwUot","checkbox":"Form1_checkbox__lyIG-","oferta":"Form1_oferta__EkBbq"};